export default __webpack_public_path__ + "static/media/singular2.30e59516.png";